import { uniqueId } from 'lodash';
import React, { ReactNode, useEffect, useState } from 'react';
import { TableBody, TableStyled } from '../Table/Table.styles';
import { ColumnType, TableRow } from '../TableRow';

interface Props<Data> {
  columns: ColumnType[];
  tableData: {
    cellData: (ReactNode | string | number)[];
    row: string;
    data?: Data;
  }[];
  'data-testid'?: string;
  fixedRowHeight?: boolean;
  isScrollable?: boolean;
  isFullWidth?: boolean;
  rowHeight?: number;
  maxRows?: number;
  borderRadius?: string;
  maxColumnWidth?: string;
  columnWidths?: (string | undefined)[];
}

export const NoHeaderTable = <Data,>(props: Props<Data>) => {
  const tableRef = React.useRef<HTMLTableElement>(null);
  const isHorizontalScrollAtZero = () => tableRef.current?.scrollLeft === 0;
  const [isScrolled, setIsScrolled] = useState(true);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(isHorizontalScrollAtZero());
    tableRef.current?.addEventListener('scroll', handleScroll);
    const ref = tableRef.current;
    return () => ref?.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <TableStyled
      data-testid={props['data-testid']}
      ref={tableRef}
      $isScrollable={!!props.isScrollable}
      $isScrolled={isScrolled}
      $maxRows={props.maxRows}
      $rowHeight={props.rowHeight}
      $isFullWidth={props.isFullWidth}
      $borderRadius={props.borderRadius}
    >
      <TableBody>
        {props.tableData.map((data) => (
          <TableRow
            cellData={data.cellData}
            data-testid={`${props['data-testid']}-row-${data.row}`}
            key={`${data.row}-${uniqueId()}`}
            fixedRowHeight={props.fixedRowHeight}
            columns={props.columns}
            maxColumnWidth={props.maxColumnWidth}
            columnsWidths={props.columnWidths}
          />
        ))}
      </TableBody>
    </TableStyled>
  );
};
